const Error404 = () => <h1>404 page</h1>;

export default Error404;
